import React from 'react';
import {useAtomValue} from "jotai";
import {groupsTabViewAtom} from "../../store.ts";
import {AddAudienceTeamsView} from "./teams/AddAudienceTeamsView.tsx";
import {AudienceListView} from "./list/AudienceListView.tsx";
import {AddAudienceIndividualsView} from "./individuals/AddAudienceIndividualsView.tsx";
import {AddAudienceManualView} from "./manual/AddAudienceManualView.tsx";

export const AudiencesTab: React.FC = () => {
    const groupView = useAtomValue(groupsTabViewAtom);

    if (groupView === 'addGroupTeams') {
        return <AddAudienceTeamsView/>;
    } else if (groupView === 'list') {
        return <AudienceListView/>
    } else if (groupView === 'addGroupIndividuals') {
        return <AddAudienceIndividualsView/>
    } else if (groupView === 'addGroupManual') {
        return <AddAudienceManualView/>
    }
};
